<template>
  <label class="cb" :class="{'combo':other}">
    <input type="checkbox" :checked='modelValue' @input="$emit('update:modelValue', $event.target.checked)" />
    <svg viewBox="-5 -4 32 32" class="check"><path d="M4 16L9 20L19 6"></path></svg>
    <span>{{label}}</span>
    <input v-if="other&&modelValue" type="text" required
    :value="otherValue"
    @input="$emit('update:otherValue', $event.target.value)"
    :placeholder="other" :name="label+' '+other"
    />
    </label>
</template>

<script>
export default {
    props:['modelValue','label','other','otherValue'],
    emits:['update:modelValue','update:otherValue']
}
</script>